<header class="header">
<router-outlet name='header'></router-outlet>
</header>
<main class="main container">
  <router-outlet></router-outlet>
</main>
<footer class="footer">
<router-outlet ngClass="container" name='footer'></router-outlet>
</footer>

